var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-content"},_vm._l((_vm.adList),function(item){return _c('div',{staticClass:"ad-content-item"},[_c('img',{attrs:{"src":item.logo,"alt":""},on:{"click":function($event){return _vm.openDetail(item)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }